import { action } from 'mobx';
import { IRecentActivityItem } from '~/types/server.types';
import type { RootStore } from '~/stores/root.store';
import { trackError } from '~/services/logger/error.utils';

export class HomeController {
    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    @action.bound
    async getOnboardingSequence() {
        const {
            userService,
            userStore: { currUser },
            homeStore
        } = this.rootStore;
        try {
            const sequence = await userService.fetchOnboardingSequence(
                currUser._id
            );

            homeStore.setOnboardingSequence(sequence);
        } catch (error) {
            homeStore.setupGuideLogger.trackError({
                error,
                message: 'Get onboarding sequence failed',
                context: { userId: currUser._id }
            });
        }
    }

    @action.bound
    async setCompleteOnboardingStep(stepKey) {
        const { onboardingService, homeStore } = this.rootStore;
        try {
            const sequence = await onboardingService.completeOnboardingStep(
                stepKey,
                false
            );
            homeStore.setOnboardingSequence(sequence);
        } catch (error) {
            trackError({
                error,
                message: 'Set complete onboarding step failed',
                context: { stepKey }
            });
        }
    }

    @action.bound
    async getRecentActivity() {
        const { projectService, workspaceService, homeStore } = this.rootStore;

        const activityPromise = projectService.fetchRecentActivity();

        const { user_pipeline_stages } =
            await workspaceService.fetchPipelineWorkspacesCounts();

        const {
            _id: inquiryStageId,
            counts: { active }
        } = user_pipeline_stages.find(stage => stage.type_cd === 0);

        let inquiries: IRecentActivityItem[] = [];

        if (active) {
            const { data } =
                await workspaceService.fetchRecentPipelineStageWorkspaces({
                    stage_id: inquiryStageId,
                    per_page: 3
                });
            inquiries = data.map(inquiry => ({
                _id: inquiry._id,
                workspace_id: inquiry._id,
                project_id: inquiry.event._id,
                project_name: inquiry.event.event_name,
                created_at: inquiry.event.last_activity_date,
                type: 'inquiry'
            }));
        }
        const { recent_activities } = await activityPromise;

        const allItems = [...recent_activities, ...inquiries];

        if (allItems.length) {
            homeStore.setRecentActivity(allItems);
        }
    }

    @action.bound
    async getSendTestTemplates() {
        const {
            templatesService,
            userStore: { currUser },
            homeStore
        } = this.rootStore;

        const templates = await templatesService.fetchSendTestTemplates(
            currUser._id
        );
        homeStore.setSendTestTemplates(templates);
    }
}
